module.exports = __webpack_public_path__ + "static/miles-4c87fecb49643e91465a3c6bdad63246.png";